export default "__VITE_ASSET__CltD0AjO__"